import { css } from '@emotion/react';

export const shadow2xl = css({
	boxShadow: '0 25px 50px -12px #00000040',
});

export const shadowXl = css({
	boxShadow: '0 20px 25px -5px #0000001a, 0 10px 10px -5px #0000000a',
});

export const shadowLg = css({
	boxShadow: '0 10px 15px -3px #0000001a, 0 4px 6px -2px #0000000d',
});

export const shadowMd = css({
	boxShadow: '0 4px 6px -1px #0000001a, 0 2px 4px -1px #0000000f',
});

export const shadowSm = css({
	boxShadow: '0 1px 2px 0 #0000000d',
});

export const shadowHighlighted = css({
	boxShadow: '0px 0px 12px #0000001f',
});

export const shadow = css({
	boxShadow: '0 1px 3px 0 #0000001a, 0 1px 2px 0 #0000000f',
});
